import { c as _c } from "react/compiler-runtime";
import { BreadcrumbsData } from '@systemeio/ui';
import { EmailPreview } from 'modules/mailing/email-statistics/components/email-preview';
import { MailingStatistic } from 'modules/mailing/email-statistics/components/mailing-statistic';
import { SummaryStatisticsTable } from 'modules/mailing/email-statistics/components/summary-statistics-table';
import { EmailStatisticsLoco } from 'modules/mailing/email-statistics/constants/email-statistics-loco';
import { useEmailPreview } from 'modules/mailing/email-statistics/hooks/use-email-preview';
import { useUserData } from 'modules/mailing/email-statistics/hooks/use-user-data';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import React from 'react';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';

// the page is reused in management section
const CampaignStepStatistics: NextPage<{
  isAdminPage?: boolean;
}> = t0 => {
  const $ = _c(28);
  const {
    isAdminPage: t1
  } = t0;
  const isAdminPage = t1 === undefined ? false : t1;
  const router = useRouter();
  const mailingId = Number(router.query.mailingId) as MailingId;
  let t2;
  if ($[0] !== isAdminPage || $[1] !== mailingId) {
    t2 = {
      mailingId,
      isFetchAllowed: isAdminPage
    };
    $[0] = isAdminPage;
    $[1] = mailingId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    userData
  } = useUserData(t2);
  const {
    t
  } = useLocoTranslation();
  let t3;
  if ($[3] !== mailingId) {
    t3 = {
      emailId: mailingId
    };
    $[3] = mailingId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    emailPreviewData
  } = useEmailPreview(t3);
  let t4;
  if ($[5] !== emailPreviewData?.email.subject || $[6] !== isAdminPage || $[7] !== t || $[8] !== userData) {
    t4 = isAdminPage ? [{
      caption: t("dashboard.email_delivery_statistics.title"),
      href: "/management/emails-delivery-statistics",
      isStatic: true
    }, {
      caption: userData?.email || "",
      href: userData ? `/management/emails-delivery-statistics/${userData.id}` : "",
      isStatic: false
    }, {
      caption: emailPreviewData?.email.subject || "",
      isStatic: false
    }] : [{
      caption: t("dashboard.email_statistics.breadcrumbs_title"),
      href: "/email-statistics",
      isStatic: true
    }, {
      caption: emailPreviewData?.email.subject || "",
      isStatic: false
    }];
    $[5] = emailPreviewData?.email.subject;
    $[6] = isAdminPage;
    $[7] = t;
    $[8] = userData;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const breadcrumbsData = t4;
  const t5 = !emailPreviewData;
  let t6;
  if ($[10] !== breadcrumbsData || $[11] !== t5) {
    t6 = <BreadcrumbsDashboard data={breadcrumbsData} isFetching={t5} />;
    $[10] = breadcrumbsData;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = emailPreviewData?.email;
  let t8;
  if ($[13] !== t7) {
    t8 = <EmailPreview email={t7} className="ml-auto md:ml-0" />;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="mb-5 flex flex-row flex-wrap justify-between gap-2 md:flex-nowrap">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = !emailPreviewData;
  const t11 = emailPreviewData?.stats;
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <SummaryStatisticsTable isLoading={t10} summaryStatistics={t11} />;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== isAdminPage || $[22] !== mailingId) {
    t13 = <MailingStatistic mailingId={mailingId} isAdminPage={isAdminPage} />;
    $[21] = isAdminPage;
    $[22] = mailingId;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13 || $[26] !== t9) {
    t14 = <>{t9}{t12}{t13}</>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t9;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
export const getServerSideProps = getBaseServerSideProps(EmailStatisticsLoco, 'header.top_menu.emails');
export default CampaignStepStatistics;